<div class="minus-margin">
    <div class="txn-details">
        @if (amountInAccCurrency > 0 && nativeCurrency() != currencyCode()) {
            <p class="mb-0 mt-4 text-center">
                {{ 'PARTY.CASHIER.web.deposit.conversion.text' | translate }} :
                {{ nativeAmount() | vnCurrency: nativeCurrency() }}
                =
                {{ amountInAccCurrency | vnCurrency: currencyCode() }}
            </p>
        }
    </div>
    <div class="total-stake">
        <div class="d-flex justify-content-between">
            <div>{{ 'PARTY.CASHIER.web.deposit.totalStake.text' | translate }}</div>
            <div>{{ stakeAmountToBePopulated | vnCurrency: currency }}</div>
        </div>
        <div class="potential-returns d-flex justify-content-between">
            <div>{{ 'PARTY.CASHIER.web.deposit.potentialReturns.text' | translate }}</div>
            <div>
                @if (estimatedReturn == 0) {
                    N/A
                } @else {
                    {{ estimatedReturn | vnCurrency: currency }}
                }
            </div>
        </div>
    </div>
</div>
